// Scroll Animation
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();



// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();



// Reveile Animation
function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();







$(document).ready(function () {
    function checkVisibility() {
        $('.fade-in-scroll').each(function () {
            var elementTop = $(this).offset().top;
            var viewportBottom = $(window).scrollTop() + $(window).height();
            if (elementTop < viewportBottom - 1) {
                $(this).addClass('is-show');
            }
        });
    }
    checkVisibility();
    $(window).on('scroll', function () {
        checkVisibility();
    });

});






// Header Sticky

function headerSticky() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    const theLogo = document.querySelector('.sticky-logo');
    const faqCont = document.querySelector('body');
    if (!header) return;
    window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;
        if (currentScroll > 100) header.classList.add('header__inner_hove-active');
        else header.classList.remove('header__inner_hove-active');
        if (currentScroll <= 100) {
            header.style.transform = 'translateY(0)';
            theLogo.style.transform = 'translateX(0)';
        }
        else if (currentScroll < lastScrollTop) {
            header.style.transform = 'translateY(0)';
            theLogo.style.transform = 'translateX(0)';
            faqCont.classList.remove('faq-left-padding');
        }
        else {
            header.style.transform = 'translateY(-100%)';
            theLogo.style.transform = 'translateX(-100%)';
            faqCont.classList.add('faq-left-padding');
        }
        lastScrollTop = currentScroll;
    });
}

headerSticky();




$(".hero__shape-items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});



// if ($(Window).width() < 768) {
    $(".media-recognition__items").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
    });
// }






if ($(Window).width() < 768) {
    $('.stockists__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
}


$(".stockists__shape-top, .featured-products__shape-top, .nature-story__shape-top, .baobab-story__top-shape, .sustainability__shape-top, .blog__shape-top, .shop-shots__shape-top, .faq__shape-top , .baobab-benefits__shape-top").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,

});
$(".stockists__shape-bot, .featured-products__shape-bot, .nature-story__shape-bot, .sustainability-mission__bot-shape, .baobab-story__bot-shape, .sustainability__shape-bot, .shop-shots__shape-bot , .baobab-benefits__shape-bot").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});

$('.review__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    // speed: 1000,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                speed: 2000,
            }
        }
    ]
});




$(".product-range__top-wave-items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});




$(".page-hero__btn-url").on("click", function () {
    $(".page-hero__btn-url").removeClass("active");
    $(this).addClass("active");
    if ($(window).width() < 768) {
        $(".page-hero__btn").slideUp(300);
        $(".page-hero__btn-dropdown").removeClass("active");
    }
});
$(".page-hero__btn-dropdown").on("click", function () {
    if ($(window).width() < 768) {
        $(this).toggleClass("active");
        $(".page-hero__btn").stop(true, true).slideToggle(300);
    }
});




$('.fibre-benefits__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
     autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    cssEase: "linear",
    // variableWidth: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true,
                autoplay: false,
                // autoplaySpeed: 5000,
                speed: "400",
                cssEase: "ease-in-out",
            }
        }
    ]
});



$(".accordion__title.active").next(".accordion__content").show();

$(".accordion__title").on("click", function (e) {
    e.preventDefault();
    const $this = $(this);
    const $content = $this.next(".accordion__content");

    $(".accordion__content").not($content).slideUp();
    $(".accordion__title").not($this).removeClass("active");

    $content.slideToggle();
    $this.toggleClass("active");
});





function handleLoading($btn, duration = 1200) {
    const $parent = $btn.parent();
    clearTimeout($parent.data("loadingTimeout"));
    $parent.addClass("loading");
    const timeoutId = setTimeout(function () {
        $parent.removeClass("loading");
    }, duration);
    $parent.data("loadingTimeout", timeoutId);
}
$(document).on("click", ".click-loading", function (e) {
    e.preventDefault();
    handleLoading($(this));
});







$('.product__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.product__small-items',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                adaptiveHeight: true,
            }
        },
    ]
});
$('.product__small-items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    vertical: true,
});




if ($(Window).width() > 768) {
    setTimeout(function () {
        var left_height = $('.product__left').height();
        var right_height = $('.product__right').height();
        if (left_height > right_height) {
            $('.product__wrapper').height(left_height);
        }
        else {
            $('.product__wrapper').height(right_height);
        }
    }, 500);
}









$(".header__menu").on("click", function () {
    $("body").toggleClass("navShown");
    if ($("body").hasClass("navShown")) {
        $(".mobi-nav").show();
        $(this).text("CLOSE");
    } else {
        $(this).text("MENU");
        setTimeout(function () {
            $(".mobi-nav").hide();
        }, 500);
    }
});


if ($(window).width() < 768) {
    $("li.has-subnav").each(function () {
        var $this = $(this);

        $this.find(" > a").click(function (e) {
            e.preventDefault();
            $("li.has-subnav").removeClass("subnav-show");
            $(".mega-menu").slideUp();
            if ($this.find(".mega-menu:visible").length) {
                $("li.has-subnav").removeClass("subnav-show");
                $(".mega-menu").slideUp();
            } else {
                $("li.has-subnav").addClass("subnav-show");
                $this.find(".mega-menu").slideDown();
            }
        });
    });
}







$(".mega-menu").parent("li").addClass("has-subnav");
if ($(window).width() > 768) {
    $(".has-subnav > a").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $parent = $(this).parent();
        var $currentMenu = $parent.children(".mega-menu");
        $(".has-subnav")
            .not($parent)
            .children(".mega-menu")
            .stop(true, true)
            .slideUp();
        $currentMenu.stop(true, true).slideToggle();
    });
    $(document).on("click", function () {
        $(".mega-menu").stop(true, true).slideUp();
    });
    $(".mega-menu").on("click", function (e) {
        e.stopPropagation();
    });
}



$(".cart-drawer-trigger").click(function (e) {
    e.preventDefault();
    $("body").addClass("cart-shown");
});
$(document).on("click", ".cart-close", function (e) {
    $("body").removeClass("cart-shown");
});
$(".cart-empty-btn").click(function () {
    $("body").removeClass("cart-shown");
});
$(".cart-backdrop").click(function () {
    $("body").removeClass("cart-shown");
});
$(".cart-backdrop").click(function () {
    $("body").removeClass("cart-shown");
});






jQuery(function ($) {
  const pathParts = window.location.pathname.split('/');

  if (pathParts[1] === 'collections' && pathParts[2]) {
    const collectionHandle = pathParts[2];
    const $target = $('#' + collectionHandle);

    if ($target.length) {
      setTimeout(function () {
        $('html, body').animate({
          scrollTop: $target.offset().top
        }, 800);
      }, 100);
    }
  }
});

$(".newsletter-trigger").on("click", function (e) {
    e.preventDefault();
    console.log("clicked");
    $(".nl-modal-wrapper").addClass("nl-open").fadeIn();
});

$(".nl-close-btn a, .nl-modal-bg").on("click", function (e) {
    e.preventDefault();
    $(".nl-modal-wrapper").fadeOut().removeClass("nl-open");
});



$(".read-next__top-shape-items , .read-next__bottom-shape-items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});


$(document).on('click', '.product__quan-plus', function () {
    var $input = $(this).siblings('.product__quan-input');
    var currentVal = parseInt($input.val()) || 1;

    $input.val(currentVal + 1).trigger('change');
});

$(document).on('click', '.product__quan-minus', function () {
    var $input = $(this).siblings('.product__quan-input');
    var currentVal = parseInt($input.val()) || 1;

    if (currentVal > 1) {
        $input.val(currentVal - 1).trigger('change');
    }
});

// Prevent invalid input
$(document).on('input', '.product__quan-input', function () {
    var value = parseInt($(this).val()) || 1;

    if (value < 1) {
        value = 1;
    }

    $(this).val(value);
});




$(".king-story-discount__shape-bot, .king-story-discount__shape-items").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
    });